
var timeouts = {
    // Set the different timeouts based on what type of slide defined in
    // "data-slide-type".
    // Time in milliseconds
    "still": 4000,
    "video": 6000
};

function calculateTimeout(currentElement) {
    // This sets the appropriate slide timeout time based on the type of slide
    // and sets the speed based on the timeouts object.
    var slideType = $(currentElement).data("slide-type");
    return timeouts[slideType];
}

// **************************************
// When the DOM is ready...
// **************************************

// .get() is used to get the actual DOM element for the "play", "paused" and
// "currentTime" to be used on the video.
// http://stackoverflow.com/a/4647069

function pauseAllVideos() {
    $(".slider-video").get(0).pause();
}

function playSelectedVideo() {
    var index = $(".activeSlide").data("pager-index");
    var $video = $(".slide[data-slide-index='"+index+"'] .slider-video");

    // Test whether or not there is a video element for the clicked pager
    if ($video.length) {
        // Reset the video to the start.
        $video.get(0).currentTime = 0;
        // Add the loop attribute
        $video.get(0).loop = true;
        // Then play.
        $video.get(0).play();
    }
}

function labelPagerIndexes() {
    // This funciton counts the spans used as pagers and adds indexes to those
    // spans and then their corresponding slide divs. This allows them to be
    // connected from what page is clicked to what video should be affected.

    $( "#showcase .slide" ).each(function( index ){
         $(".pager").append( "<span data-pager-index='" + index + "'></span>");
         $( this ).attr("data-slide-index", index );
    });
}

/* Executed after resources are loaded */
function initSlides() {
    labelPagerIndexes();

    // Showcase slideshow
    $("#showcase .container").cycle({
        before: function() {
            var thisVid = $(this).find("video");
            // play the html5 video if one is present
            if (thisVid.length == 1) {
                thisVid[0].play();
            }
        },
        cleartypeNoBg : true,
        timeoutFn: calculateTimeout,
        speed: 1000,
        pager: ".pager",
        pagerAnchorBuilder: function(idx) {
            // return selector string for existing anchor
            return ".pager span:eq(" + idx + ")";
        }
    });

    // Pause slideshow when pager is clicked
    $(".pager").click(function() {
        $("#showcase .container").cycle("pause");
        pauseAllVideos();
        playSelectedVideo();
    });

    // Cycle Build Your Own images
    $("#volumes").cycle({
        cleartypeNoBg : true
    });
};
